import { Link } from "@StarberryUtils"
import React from "react";
import { Button} from 'react-bootstrap';
import './StepZero.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import { TORENT_Manchester_PAGE_URL, FORSALE_Manchester_PAGE_URL } from "@Components/common/site/constants";

const StepZero = (props) => {
  const selectValuationType = (event) => {
    props.setValuationType(event)
    sessionStorage.setItem('type_of_valuation', event)
    props.next()
}

const divgaltracking = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'formSubmit',
    'formType': 'form- Digival - instant valuation',
    'formId': 'form- Digival - instant valuation',
    'formName': 'Digival - instant valuation',
    'formLabel': 'Digival - instant valuation'
  });
  window.open("http://valuation.bentleyhurst.co.uk/", "_blank")
}

  return (
    <div className="stepzero">
      <div className="d-lg-block">
         {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true}> */}
          <div onClick={props.step === 0 ? props.handleBack : props.previous} onKeyPress={props.step === 0 ? props.handleBack : props.previous} className="back_icon"><i className="icon-back"></i> Back</div>
        {/* </ScrollAnimation> */}
      </div>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <h2>Wondering “How much is my property worth?” Find out now!</h2>
      </ScrollAnimation>
      <div className="box">
                <h4>Free property valuation</h4>
                <p>Get an accurate property valuation from an expert</p>
                <Link to="/property-valuation/book-a-valuation/">
                  <Button className="btn">Book a valuation</Button>
                </Link>
            </div>
            <div className="box">
                <h4>Online house valuation</h4>
                <p>Get an approximate price from instant valuation in minutes</p>
                <Button className="btn" onClick={()=> divgaltracking()}>Instant Valuation</Button>
            </div>
            <p>Get your property valuation in Manchester with local expert valuers. Specialists in determining the precise value of the property, when you choose the online property valuation in Manchester, you're only a few clicks away from getting an accurate valuation to know the actual worth of your property. Whether you are planning to rent or sell, we strive to sell every home at the best possible price to help you gain the returns you deserve with an honest valuation.Rental valuation in Manchester is always hassle-free with our experts!</p>
      </div>
  )
}



export default StepZero
